import { ThemeOptions, ThemeProvider } from '@acceso/design-system';

import '@fontsource/inter';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/900.css';

import './index.css';
import { RootProvider } from './providers/root';
import { Router } from './routes/components/Router';

// TODO: Forzar reload completo durante desarrollo
if (import.meta.hot) {
  import.meta.hot.on('vite:beforeUpdate', () => {
    window.location.reload();
  });
}

function App() {
  return (
    <ThemeProvider initialTheme={ThemeOptions.OLIVA}>
      <RootProvider>
        <Router />
      </RootProvider>
    </ThemeProvider>
  );
}

export default App;
